import React, { useState, useEffect } from "react";
import {
  Container,
  CircularProgress,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Grid,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Autocomplete,
  useMediaQuery,
  useTheme,
  Badge,
  Link,
  Tooltip,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  UpdateContractActive,
  UpdateContractVersion,
  CopyHHContract,
  FetchData,
  FetchTemplateLibraryData,
  FetchCommentByContractVersionId,
  FetchAdditionalFilesByContractVersionId,
  DeleteComment,
  ReplyComment,
} from "../api/contractVersionService";
import toast from "react-hot-toast";
import Download from "@mui/icons-material/Download";
import ConfirmationDialog from "../confirm/confirmation";
import {
  ACTION,
  HHCONTRACTSTATUSENUMTYPE,
  USERROLE,
} from "../utils/commonConstant";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { DataGrid } from "@mui/x-data-grid";
import "../App.css";
import FileUploadPopup from "../ModelPopup/FileUploadPopup";
import CommentDialogPopup from "./../ModelPopup/CommentPopup";
import AdditionalFileViewPopup from "../ModelPopup/AdditionalFileViewPopup";
import HeaderLogo from "../components/LogoHeader";
import axios from "axios";
import ContractPreviewPopup from "../ModelPopup/ContractPreviewPopup";
import AuditHistoryPopup from "../ModelPopup/AuditHistoryPopup";
import { processParaResetForNewContract } from "../utils/formUtils";
import axiosInstanceInterceptor from "../utils/axiosInstanceInterceptor";
import { fetchFromWebApi } from "../utils/fetchFromWebApi";
import ContractPresentModePopup from "../ModelPopup/ContractPresentModePopup";
import { getOrRefreshBearerToken } from "../services/bearerToken.service";
import { API_VERSION } from "../utils/commonConstant";

const ContractVersion = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [templateDialogOpen, setTemplateDialogOpen] = useState(false);
  const [openFileUploadPopup, setOpenFileUploadPopup] = useState(false);
  const [fileuploadData, setFileUploadData] = useState(null);
  const [editData, setEditData] = useState({
    VersionName: "",
    HHApprovalStatus: "",
    InsurerApprovalStatus: "",
    COApprovalStatus: "",
    IsActive: false,
  });
  const { clientId, hhDocumentId, hhTemplateId } = useParams();
  const navigate = useNavigate();
  const approvalStatus = ["Pending", "Approved"];
  const [optionTemplateLibrary, setOptionTemplateLibrary] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [errors, setErrors] = useState({
    template: "",
  });

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [rowToConfirm, setRowToConfirm] = useState(null);
  const [confirmHHDialogOpen, setConfirmHHDialogOpen] = useState(false);
  const [confirmIsActiveDialogOpen, setConfirmIActiveDialogOpen] =
    useState(false);
  const [confirmCOApprovalDialogOpen, setConfirmCOApprovalialogOpen] =
    useState(false);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
  });
  const [commentDialogOpen, setCommentDialogOpen] = useState(false); // State for dialog
  const [comment, setComment] = useState(""); // State for comment
  const fetchTemplateLibrary = async () => {
    const data = await FetchTemplateLibraryData();
    setOptionTemplateLibrary(data);
  };
  const [rows, setRows] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [comments, setComments] = useState([]);
  const [additionalFileOpen, setAdditionalFileOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [elements, setElements] = useState([]);
  const [openPreview, setOpenPreview] = useState(false);
  const [clientName, setClientName] = useState("");
  const [documentName, setDocumentName] = useState("");
  const [auditHistoryPopup, setAuditHistoryPopup] = useState({
    open: false,
    data: null,
  });
  const [contractPresentModeState, setContractPresentModeState] = useState({
    open: false,
    date: null,
  });
  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 50,
      headerClassName: "bold-header",
    },
    {
      field: "VersionName",
      headerName: "Version Name",
      width: 200,
      align: "center",
      headerAlign: "center",
      headerClassName: "bold-header",
      renderCell: (params) => {
        const editRenderLink = true;
        // (params.row.HHApprovalStatus === HHCONTRACTSTATUSENUMTYPE.PENDING &&
        //   params.row.COApprovalStatus === HHCONTRACTSTATUSENUMTYPE.PENDING) ||
        // (params.row.HHApprovalStatus === HHCONTRACTSTATUSENUMTYPE.APPROVED &&
        //   params.row.COApprovalStatus === HHCONTRACTSTATUSENUMTYPE.REJECTED);
        return editRenderLink ? (
          <Link
            href={`/${clientId}/${hhDocumentId}/versions/${params.row.TemplateId}/${ACTION.EDIT}/${params.row.Id}`}
            underline="hover"
            sx={{
              color: "text.primary",
              "&:hover": {
                color: "primary.main",
              },
            }}
          >
            {params.value}
          </Link>
        ) : (
          <span>{params.value}</span>
        );
      },
    },
    {
      field: "HHApprovalStatus",
      headerName: "HardHats",
      width: 150,
      align: "center",
      headerClassName: "bold-header",
      headerAlign: "center",
      renderCell: (params) => (
        <Badge
          color={getBadgeColor(params.row.HHApprovalStatus)}
          badgeContent={params.row.HHApprovalStatus}
        />
      ),
    },
    {
      field: "COApprovalStatus",
      headerName: clientName,
      width: 150,
      align: "center",
      headerAlign: "center",
      headerClassName: "bold-header",
      renderCell: (params) => (
        <Badge
          color={getBadgeColor(params.row.COApprovalStatus)}
          badgeContent={params.row.COApprovalStatus}
        />
      ),
    },
    {
      field: "InsurerApprovalStatus",
      headerName: "Markel",
      align: "center",
      headerAlign: "center",
      headerClassName: "bold-header",
      width: 150,
      renderCell: (params) => (
        <Badge
          color={getBadgeColor(params.row.InsurerApprovalStatus)}
          badgeContent={params.row.InsurerApprovalStatus}
        />
      ),
    },
    {
      field: "IsActive",
      headerName: "Active",
      width: 120,
      align: "center",
      headerClassName: "bold-header",
      headerAlign: "center",
      renderCell: (params) => (
        <IconButton onClick={() => handleIsActiveToggle(params.row)}>
          {params.row.IsActive ? (
            <CheckIcon color="primary" />
          ) : (
            <CloseIcon color="error" />
          )}
        </IconButton>
      ),
    },
    {
      field: "Status",
      headerName: "Status",
      width: 150,
      align: "center",
      headerAlign: "center",
      headerClassName: "bold-header",
      renderCell: (params) => (
        <Badge
          color={getBadgeColor(params.row.Status)}
          badgeContent={params.row.Status}
        />
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 160,
      sortable: false,
      align: "center",
      headerClassName: "bold-header",
      headerAlign: "center",
      renderCell: (params) => (
        <Box>
          <Tooltip title="Download Pdf" arrow>
            <IconButton
              color="success"
              aria-label="Download PDF"
              onClick={() => handleDownloadContract(params.row)}
            >
              <Download />
            </IconButton>
          </Tooltip>

          <Tooltip title="Copy URL" arrow>
            <IconButton
              color="info"
              aria-label="Copy URL"
              onClick={() => handleCopyUrl(params.row)}
            >
              <ContentCopyIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Action" arrow>
            <IconButton onClick={(event) => handleMenuOpen(event, params.row)}>
              <MoreVertIcon />
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleEdit}>Edit</MenuItem>
            <MenuItem onClick={handleCopyContract}>Duplicate</MenuItem>
            <MenuItem onClick={handleSubmitForApproval}>
              Submit To Client
            </MenuItem>
            {selectedRow?.HHApprovalStatus === HHCONTRACTSTATUSENUMTYPE.APPROVED && (
              <MenuItem onClick={handleSendToMarkel}>Send To Markel</MenuItem>
            )}
            <MenuItem onClick={() => handleAddComment(selectedRow)}>
              Add Comment
            </MenuItem>
            {selectedRow?.IsComment && (
              <MenuItem onClick={() => handleViewComment(selectedRow)}>
                View Comment
              </MenuItem>
            )}

            {selectedRow?.IsAdditionalFile && (
              <MenuItem onClick={() => handleFileIconClick(selectedRow)}>
                View Additional Files
              </MenuItem>
            )}
            {selectedRow?.HHApprovalStatus ===
              HHCONTRACTSTATUSENUMTYPE.APPROVED && (
                <MenuItem onClick={() => handlePreviewClick(selectedRow)}>
                  Preview Submitted Doc
                </MenuItem>
              )}
            <MenuItem onClick={() => handleShowAuditHistory(selectedRow)}>
              Show Audit History
            </MenuItem>
            <MenuItem onClick={() => handlePresentModeContract(selectedRow)}>
              Present Mode
            </MenuItem>
          </Menu>
        </Box>
      ),
    },
  ];
  const fetchDocumentWithClient = async () => {
    try {
        const API_BASE_URL = `${process.env.REACT_APP_BASE_API_URL}${API_VERSION}`;
      let bearerToken = await getOrRefreshBearerToken();
      const response = await axiosInstanceInterceptor.get(
        `${API_BASE_URL}HHDocument/GetHHDocumentById?id=${hhDocumentId}`,
        {
          headers: {
            "Authorization": `Bearer ${bearerToken}`, // Add the token here
            // "Content-Type": "application/json", // Optional, if required by the API
          },
        }
      );
      setClientName(response.data.ClientName);
      setDocumentName(response.data.Name);
    } catch (error) {
      console.error("Error fetching client details:", error);
    }
  };
  const fetchData = async () => {
    try {
      const result = await FetchData(clientId, hhDocumentId);
      setData(result);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };
  const addIdToData = (data) => {
    // Create a new array with 'id' field added to each object
    return data.map((item) => ({ ...item, id: item.Id }));
  };

  useEffect(() => {
    fetchData();
    fetchTemplateLibrary();
    fetchDocumentWithClient();
  }, [clientId, refresh]);

  useEffect(() => {
    const updatedRows = addIdToData(data);
    setRows(updatedRows);
    console.log(selectedRow);
  }, [data, selectedRow]);

  if (loading) {
    return (
      <Container>
        <CircularProgress />
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Typography color="error">
          Error fetching data: {error.message}
        </Typography>
      </Container>
    );
  }
  const handlePreviewClick = async (row) => {
    console.log(row);
    setElements(row.MetaData);
    setOpenPreview(true);
  };
  const handleFileIconClick = async (row) => {
    console.log("Open file for:", row);
    // Handle file open logic here
    setAdditionalFileOpen(true);
    const data = await FetchAdditionalFilesByContractVersionId(row.Id);
    const dataWithid = data.map((file) => ({
      id: file.Id,
      ...file,
    }));
    setFiles(dataWithid);
  };
  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };
  const handleCommentDialogClose = () => {
    setCommentDialogOpen(false); // Close the dialog
    handleMenuClose();
  };
  const handleDeleteComment = async (commentId, isReplyDelete) => {
    console.log(commentId);
    const resp = await DeleteComment(commentId);
    if (resp.ok) {
      toast.success(
        `Comment ${isReplyDelete ? "Reply" : ""} deleted  successfully.`
      );
    }
  };
  const handleReplyComment = async (parentCommentId, comment) => {
    console.log(parentCommentId, comment);
    const resp = await ReplyComment({
      parentCommentId: parentCommentId,
      commentReply: comment,
      userId: localStorage.getItem("UserId"),
    });
    if (resp) {
      toast.success("Comment replied successfully.");
    }
  };

  const handleAdditionalFileClose = () => {
    setAdditionalFileOpen(false);
    handleMenuClose();
    setRefresh(true);
  };
  const handleCommentSubmit = async () => {
    console.log("Comment:", comment);
    console.log(selectedRow, "selectedRow");
    const resp = await handleSaveCommentApi({
      contractVersionId: selectedRow.Id,
      comment: comment,
    });
    handleMenuClose();
    setCommentDialogOpen(false);
    setComment("");
  };
  const handleEdit = () => {
    setEditData(selectedRow);
    setEditDialogOpen(true);
    handleMenuClose();
  };
  const handleSaveCommentApi = async (commentRequest) => {
    try {
      const res = await fetchFromWebApi(
        `HHContract/CreateComment`,
        {
          method: "POST",
          body: JSON.stringify({
            contractVersionId: commentRequest.contractVersionId,
            comment: commentRequest.comment,
            userId: localStorage.getItem("UserId"),
          }),
        }
      );
      setLoading(false);
      if (res?.ok) {
        toast.success(`Comment added successfully.`);
      } else {
        console.error("Failed to save form:", await res.text());
        toast.error("Failed to sign contract:", await res.text());
      }
    } catch (error) {
      setLoading(false);
      toast.error(`Failed to add comment.`);
    }
  };
  const handleActivateContract = async () => {
    console.log("Update Status:", rowToConfirm);
    const resp = await UpdateContractActive(rowToConfirm.Id);
    console.log("handleActivateContract :", resp);
    handleMenuClose();
    fetchData(); // Refresh data after update
    toast.success("Contract is activated successfully.");
    setConfirmIActiveDialogOpen(false);
  };
  const handleIsActiveToggle = async (row) => {
    setConfirmIActiveDialogOpen(true);
    setRowToConfirm(row);
  };
  const handleCopyContract = async () => {
    console.log("Update Status:", selectedRow);
    const elements = selectedRow.MetaData;
    const resetElement = (element) => {
      switch (element.type) {
        case "signature":
          return { ...element, props: { ...element.props, value: "", disabled: false } };

        case "horizontalContainer":
          if (Array.isArray(element.items)) {
            const updatedItems = element.items.map((item) =>
              item.type === "signature"
                ? { ...item, props: { ...item.props, value: "", disabled: false } }
                : item.type === "paragraph"
                  ? {
                    ...item,
                    props: {
                      ...item.props,
                      comments: [],
                      trackChangesComments: {},
                      trackHistorys: {},
                      text: processParaResetForNewContract(item.props.text),
                    },
                  }
                  : item
            );
            return { ...element, items: updatedItems };
          }

          return element;

        case "paragraph":
          return {
            ...element,
            props: {
              ...element.props,
              comments: [],
              trackChangesComments: {},
              trackHistorys: {},
              text: processParaResetForNewContract(element.props.text),
            },
          };

        default:
          return element;
      }
    };

    const updatedElements = elements.map(resetElement);

    console.log("Copy Contract Data MetaData:", updatedElements);
    const resp = await CopyHHContract(selectedRow.Id, updatedElements);
    console.log("handleActivateContract :", resp);
    handleMenuClose();
    fetchData(); // Refresh data after update
    toast.success("Contract is copied successfully.");
  };

  const handleSubmitForApproval = async () => {
    setFileUploadData(selectedRow);
    setOpenFileUploadPopup(true);
    handleMenuClose();
  };
  const handleShowAuditHistory = async (row) => {
    setAuditHistoryPopup((prev) => ({ ...prev, open: true, data: row }));
    handleMenuClose();
  };
  const handlePresentModeContract = async (row) => {
    console.log("Present Mode Contract", row);
    setContractPresentModeState((prev) => ({ ...prev, open: true, data: row }));
    handleMenuClose();
  }

  const handleSendToMarkel = async () => {
    console.log(selectedRow, "SelectedRow");
    try {
      const res = await fetchFromWebApi(
        `HHContract/SendToMarkel`,
        {
          method: "POST",
          body: JSON.stringify({
            id: selectedRow.Id,
            userId: localStorage.getItem("UserId"),
          }),
        }
      );

      if (res?.ok) {
        toast.success("Document sent successfully.");
        fetchData(); // Refresh data after sending
      } else {
        console.error("Failed to save form:", await res.text());
        toast.error("Failed to save form:", await res.text());
      }
    } catch (error) {
      console.error("Error while saving form:", error);
      toast.error("Error while saving form:", error);
    }
    handleMenuClose();
  };
  const handleFileUploadPopupClose = () => {
    setOpenFileUploadPopup(false);
    setFileUploadData(null);
    setRefresh(true);
  };
  const handleCommentChange = (event) => {
    setComment(event.target.value); // Update comment state
  };

  const handleAddComment = async (row) => {
    setCommentDialogOpen(true);
  };
  const handleViewComment = async (row) => {
    const data = await FetchCommentByContractVersionId(row.Id); // Fetch comments based on the row's ID
    setComments(data);
    setDialogOpen(true);
  };
  const handleCloseComment = () => {
    setDialogOpen(false);
    setComments([]);
    handleMenuClose();
  };

  const handleBack = () => {
    navigate(`/${clientId}`);
    //window.history.back();
  };
  const handleAutocompleteTemplateChange = (event, newValue) => {
    setErrors({ ...errors, template: "" });
    setSelectedOption(newValue);
  };
  const handleCreate = () => {
    navigate(
      `/${clientId}/${hhDocumentId}/versions/${hhTemplateId}/${ACTION.CREATE}`
    );
  };
  const handleTemplate = () => {
    navigate(`/${clientId}/template`);
  };

  const handleEditDialogClose = () => {
    setEditDialogOpen(false);
  };
  const handleTemplateDialogClose = () => {
    setTemplateDialogOpen(false);
  };
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditData({ ...editData, [name]: value });
  };

  const handleAutocompleteChange = (event, newValue, fieldName) => {
    setEditData({ ...editData, [fieldName]: newValue });
  };

  const handleEditSave = async () => {
    try {
      console.log("Save Edit Data:", editData);
      const updatedContract = await UpdateContractVersion(
        editData.Id,
        editData
      );
      console.log("Save Edit:", updatedContract);
      fetchData(); // Refresh data after update
      // Optionally update state or handle success message
      toast.success("Updated successfully.");
    } catch (error) {
      // Handle error
    }
    setEditDialogOpen(false);
  };
  const handleTemplateSave = async () => {
    debugger;
    const newErrors = { ...errors };
    if (!selectedOption) {
      newErrors.template = "Template  is required";
      setErrors(newErrors);
      return;
    }
    setTemplateDialogOpen(false);
    console.log(selectedOption.Id);
    navigate(
      `/${clientId}/${hhDocumentId}/versions/${selectedOption.Id}/${ACTION.CREATE}`
    );
  };
  const handleDownloadContract = (row) => {
    //const currentUrl = window.location.href;
    const baseURL = `${window.location.protocol}//${window.location.host}`;
    const pdfDownloadUrl = `${process.env.REACT_APP_HHMANAGER_AWS_LAMBDA_PDF_URL}/?url=${baseURL}/${clientId}/download/${row.Id}`;
    console.log(pdfDownloadUrl, "pdfDownloadUrl");
    window.open(pdfDownloadUrl, "_blank");
  };

  const handleCopyUrl = (row) => {
    //const currentUrl = window.location.href;
    const baseURL = `${window.location.protocol}//${window.location.host}`;
    console.log(baseURL);
    const textToCopy = `${baseURL}/${clientId}/download/${row.Id}`;
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        toast.success(`URL copied to clipboard.`);
      })
      .catch((err) => {
        toast.error("Failed to copy URL: ", err);
      });
  };
  // const handleToggleHHApproval = async (row) => {
  //   const updatedStatus = row.HHApprovalStatus === 'Approved' ? 'Pending' : 'Approved';
  //   const updatedData = {
  //     ...row,
  //     HHApprovalStatus: updatedStatus
  //   };
  //   try {
  //     await UpdateContractVersion(row.Id, updatedData); // Assuming this function handles the API call to update the contract
  //     fetchData(); // Refresh data after update
  //     toast.success(`HH Approval Status updated to ${updatedStatus}`);
  //   } catch (error) {
  //     toast.error("Error updating HH Approval Status");
  //   }
  // };
  const handleToggleHHApproval = (row) => {
    setRowToConfirm(row);
    setConfirmHHDialogOpen(true);
  };
  const confirmToggleHHApproval = async () => {
    const updatedStatus =
      rowToConfirm.HHApprovalStatus === "Approved" ? "Pending" : "Approved";
    const updatedData = {
      ...rowToConfirm,
      HHApprovalStatus: updatedStatus,
    };
    try {
      await UpdateContractVersion(rowToConfirm.Id, updatedData); // Assuming this function handles the API call to update the contract
      fetchData(); // Refresh data after update
      toast.success(`HH Approval Status updated to ${updatedStatus}`);
    } catch (error) {
      toast.error("Error updating HH Approval Status");
    }
    setConfirmHHDialogOpen(false);
    setRowToConfirm(null);
  };
  // const handleToggleInsurerApproval = async () => {
  //   const updatedStatus = rowToConfirm.InsurerApprovalStatus === 'Approved' ? 'Pending' : 'Approved';
  //   const updatedData = {
  //     ...rowToConfirm,
  //     InsurerApprovalStatus: updatedStatus
  //   };
  //   try {
  //     await UpdateContractVersion(rowToConfirm.Id, updatedData); // Assuming this function handles the API call to update the contract
  //     fetchData(); // Refresh data after update
  //     toast.success(`Insurer Approval Status updated to ${updatedStatus}`);
  //   } catch (error) {
  //     toast.error("Error updating Insurer Approval Status");
  //   }
  //   setConfirmDialogOpen(false);
  //   setRowToConfirm(null);
  // };
  const handleToggleInsurerApproval = (row) => {
    setRowToConfirm(row);
    setConfirmDialogOpen(true);
  };

  const handleToggleCOApproval = (row) => {
    setRowToConfirm(row);
    setConfirmCOApprovalialogOpen(true);
  };
  const confirmToggleCOApproval = async () => {
    const updatedStatus =
      rowToConfirm.COApprovalStatus === "Approved" ? "Pending" : "Approved";
    const updatedData = {
      ...rowToConfirm,
      COApprovalStatus: updatedStatus,
    };
    try {
      await UpdateContractVersion(rowToConfirm.Id, updatedData); // Assuming this function handles the API call to update the contract
      fetchData(); // Refresh data after update
      toast.success(`CO Approval Status updated to ${updatedStatus}`);
    } catch (error) {
      toast.error("Error updating HH Approval Status");
    }
    setConfirmCOApprovalialogOpen(false);
    setRowToConfirm(null);
  };
  const confirmToggleInsurerApproval = async () => {
    const updatedStatus =
      rowToConfirm.InsurerApprovalStatus === "Approved"
        ? "Pending"
        : "Approved";
    const updatedData = {
      ...rowToConfirm,
      InsurerApprovalStatus: updatedStatus,
    };
    try {
      await UpdateContractVersion(rowToConfirm.Id, updatedData);
      fetchData(); // Refresh data after update
      toast.success(`Insurer Approval Status updated to ${updatedStatus}`);
    } catch (error) {
      toast.error("Error updating Insurer Approval Status");
    }
    setConfirmDialogOpen(false);
    setRowToConfirm(null);
  };
  const handleCloseConfirmationDialog = () => {
    setConfirmDialogOpen(false);
    setRowToConfirm(null);
  };

  const getBadgeColor = (status) => {
    switch (status) {
      case "Approved":
        return "success";
      case "Pending":
        return "warning";
      case "Rejected":
        return "error";
      default:
        return "default";
    }
  };
  const handleClosePreview = () => {
    handleMenuClose();
    setOpenPreview(false);
    setElements([]);
  };
  return (
    <>
      <Box sx={{ padding: 2 }}>
        <HeaderLogo clientId={clientId} heading={documentName} />
        <Container>
          <Grid
            container
            justifyContent="flex-end"
            alignItems="center"
            mb={2}
            spacing={2}
          >
            <Grid item justifyContent="flex-end">
              <Button
                variant="contained"
                color="primary"
                onClick={handleCreate}
              >
                Create New Version
              </Button>
            </Grid>
            <Grid item>
              <Button variant="contained" color="primary" onClick={handleBack}>
                Back
              </Button>
            </Grid>
          </Grid>
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            pageSizeOptions={[10, 50, 100]}
            disableSelectionOnClick // Disable row selection
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
          />
        </Container>
      </Box>
      {/* model popup for edit */}
      <Dialog
        open={editDialogOpen}
        onClose={handleEditDialogClose}
        maxWidth="md"
        fullWidth={fullScreen}
      >
        <DialogTitle>Edit Contract Version</DialogTitle>
        <DialogContent sx={{ width: fullScreen ? "100%" : "600px" }}>
          <TextField
            margin="dense"
            name="VersionName"
            label="Version Name"
            type="text"
            fullWidth
            value={editData.VersionName}
            onChange={handleEditChange}
          />
          <Autocomplete
            options={approvalStatus}
            readOnly
            value={editData.HHApprovalStatus}
            onChange={(event, newValue) =>
              handleAutocompleteChange(event, newValue, "HHApprovalStatus")
            }
            renderInput={(params) => (
              <TextField
                {...params}
                readOnly
                label="HH Approval Status"
                margin="dense"
                fullWidth
              />
            )}
          />
          <Autocomplete
            options={approvalStatus}
            readOnly
            value={editData.InsurerApprovalStatus}
            onChange={(event, newValue) =>
              handleAutocompleteChange(event, newValue, "InsurerApprovalStatus")
            }
            renderInput={(params) => (
              <TextField
                {...params}
                readOnly
                label="Insurer Approval Status"
                margin="dense"
                fullWidth
              />
            )}
          />
          <Autocomplete
            options={approvalStatus}
            readOnly
            value={editData.COApprovalStatus}
            onChange={(event, newValue) =>
              handleAutocompleteChange(event, newValue, "COApprovalStatus")
            }
            renderInput={(params) => (
              <TextField
                {...params}
                readOnly
                label="CO Approval Status"
                margin="dense"
                fullWidth
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleEditSave} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
      {/* confirmation for Insurer Approval  */}
      <ConfirmationDialog
        open={confirmDialogOpen}
        onClose={handleCloseConfirmationDialog}
        onConfirm={confirmToggleInsurerApproval}
        message={`Are you sure you want to toggle Insurer Approval Status for ${rowToConfirm ? rowToConfirm.VersionName : ""
          }?`}
      />
      {/* confirmation for HH Approval  */}
      <ConfirmationDialog
        open={confirmHHDialogOpen}
        onClose={() => setConfirmHHDialogOpen(false)}
        onConfirm={confirmToggleHHApproval}
        message={`Are you sure you want to toggle HH Approval Status for ${rowToConfirm?.VersionName}?`}
      />
      {/* confirmation for Activate contract  */}

      <ConfirmationDialog
        open={confirmIsActiveDialogOpen}
        onClose={() => setConfirmIActiveDialogOpen(false)}
        onConfirm={handleActivateContract}
        message={`Are you sure you want to Activate contract for ${rowToConfirm?.VersionName}?`}
      />

      {/* confirmation for   */}
      <ConfirmationDialog
        open={confirmCOApprovalDialogOpen}
        onClose={() => setConfirmCOApprovalialogOpen(false)}
        onConfirm={confirmToggleCOApproval}
        message={`Are you sure you want to toggle CO Approval Status for ${rowToConfirm?.VersionName}?`}
      />
      {/* model popup for template select   */}
      <Dialog
        open={templateDialogOpen}
        onClose={handleTemplateDialogClose}
        maxWidth="md"
        fullWidth={fullScreen}
      >
        <DialogTitle> Template</DialogTitle>
        <DialogContent sx={{ width: fullScreen ? "100%" : "600px" }}>
          <Autocomplete
            options={optionTemplateLibrary}
            value={selectedOption}
            getOptionLabel={(option) => option.Name}
            isOptionEqualToValue={(option, value) =>
              option.valueOf === value.valueOf
            }
            onChange={(event, newValue) =>
              handleAutocompleteTemplateChange(event, newValue)
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Template"
                margin="dense"
                fullWidth
                error={!!errors.template}
                helperText={errors.template || ""}
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleTemplateDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleTemplateSave} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <FileUploadPopup
        open={openFileUploadPopup}
        onClose={handleFileUploadPopupClose}
        data={fileuploadData}
      />
      <Dialog
        open={commentDialogOpen}
        onClose={handleCommentDialogClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Write a Comment</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="comment"
            label="Comment"
            type="text"
            fullWidth
            multiline
            rows={5}
            value={comment}
            onChange={handleCommentChange}
            placeholder="Write your comment here..."
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCommentDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleCommentSubmit} color="primary">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      <CommentDialogPopup
        open={dialogOpen}
        onClose={handleCloseComment}
        comments={comments}
        onDelete={handleDeleteComment}
        onReply={handleReplyComment}
      />
      <AdditionalFileViewPopup
        open={additionalFileOpen}
        onClose={handleAdditionalFileClose}
        files={files}
      />
      <ContractPreviewPopup
        open={openPreview}
        onClose={handleClosePreview}
        elements={elements}
        clientId={clientId}
        previewTitle={"Submitted Document"}
        trackChangeDisplayBy={USERROLE.ADMIN}
        isShowTrackHistory={true}
      />
      <AuditHistoryPopup
        open={auditHistoryPopup.open}
        onClose={() =>
          setAuditHistoryPopup((prev) => ({ ...prev, open: false, data: null }))
        }
        contractVersionId={auditHistoryPopup?.data?.Id}
      />
      <ContractPresentModePopup
        open={contractPresentModeState.open}
        onClose={() =>
          setContractPresentModeState((prev) => ({ ...prev, open: false, data: null }))
        }
        elements={contractPresentModeState.data?.MetaData}
        previewTitle={"Present Mode"}
        clientId={clientId}
      />
    </>
  );
};

export default ContractVersion;
